var map = {
	"./CBLOL.webp": 3045,
	"./LCK.webp": 86264,
	"./LCS.webp": 58294,
	"./LEC.webp": 42721,
	"./LJL.webp": 20232,
	"./LLA.webp": 17660,
	"./LPL.webp": 85325,
	"./LRN.webp": 82401,
	"./LRS.webp": 15698,
	"./PCS.webp": 97032,
	"./VCS.webp": 68891,
	"./worlds.webp": 59018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52906;